import React, { useEffect, useState } from 'react';
import apiClient from '../../api/client';

export const Stars = ({ rating }) => (
  <span role="img" aria-label={`${rating} out of 5 stars`} style={{ color: '#b7791f', letterSpacing: 2 }}>
    {'★'.repeat(rating)}{'☆'.repeat(5 - rating)}
  </span>
);

/** Real customer testimonials added by partners. Renders nothing until there is at least one. */
const Testimonials = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let alive = true;
    apiClient
      .get('/testimonials/public', { params: { limit: 6 } })
      .then((res) => alive && setItems(res.data))
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  if (!items.length) return null;
  return (
    <section style={{ margin: '24px 0 32px' }}>
      <h2 className="section-title text-center">What <span className="highlight">customers</span> say</h2>
      <p className="section-sub centered">Reviews collected by our partners from people who compared on their sites.</p>
      <div className="grid-3">
        {items.map((t) => (
          <figure key={t.id} className="card" style={{ margin: 0, textAlign: 'left', display: 'flex', flexDirection: 'column', gap: 10 }}>
            <Stars rating={t.rating} />
            <blockquote style={{ margin: 0, fontSize: '0.95rem', lineHeight: 1.55 }}>“{t.comment}”</blockquote>
            <figcaption style={{ marginTop: 'auto', fontSize: '0.85rem', color: 'var(--text-muted)' }}>
              <strong style={{ color: 'var(--text)' }}>{t.name}</strong> · via {t.partner}
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
